export const ERROR_LEVEL = {
    FATAL: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3
};
